import { useState, useEffect } from 'react';

interface ParallaxOptions {
  speed?: number;
}

export const useParallax = (options: ParallaxOptions = {}) => {
  const { speed = 1 } = options;
  const [position, setPosition] = useState({ x: 0, y: 0 });

  useEffect(() => {
    const handleMouseMove = (event: MouseEvent) => {
      let x = (event.clientX / window.innerWidth * 10) - 5;
      let y = (event.clientY / window.innerHeight * 10) - 5;

      // Reverse the numbers
      x = x - (x * 2);
      y = y - (y * 2);

      setPosition({
        x: x * speed,
        y: y * speed,
      });
    };

    window.addEventListener('mousemove', handleMouseMove);
    return () => window.removeEventListener('mousemove', handleMouseMove);
  }, [speed]);

  return position;
};
